<section class="flex flex-col flex-auto min-w-0 w-full bg-slate-50">
  <div class="max-w-3xl w-full mx-auto px-6 pt-8 pb-10">
    <!-- Digitap Payment Report -->
    <div class="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden">

      <div class="px-6 py-4 border-b border-slate-100 flex items-center justify-center gap-3">
        <span class="inline-flex items-center justify-center w-9 h-9 rounded-xl bg-emerald-100 flex-shrink-0">
          <mat-icon class="!text-emerald-700 !text-lg !leading-none">payments</mat-icon>
        </span>
        <div class="min-w-0">
          <div class="flex items-center gap-2">
            <h3 class="text-base font-semibold text-slate-800">Digital Payment Report</h3>
            <span
              class="flex-shrink-0 text-[10px] font-semibold px-2 py-0.5 rounded-full bg-slate-100 text-slate-500 tracking-wide">XLSX</span>
          </div>
          <p class="text-sm text-slate-500 mt-0.5">Fee collection transactions</p>
        </div>
      </div>

      <!-- Filters -->
      <div class="px-6 pt-5 pb-5 bg-slate-50/60">

        <!-- Quick ranges -->
        <div class="flex items-center gap-2 flex-wrap mb-4">
          <span class="text-md font-medium text-slate-400 mr-0.5">Quick range</span>
          @for (preset of presets; track preset.key) {
          <button type="button" (click)="applyPreset(preset)"
            class="text-md font-medium px-3 py-1.5 rounded-full border transition-colors" [ngClass]="activePreset() === preset.key
              ? 'bg-emerald-50 border-emerald-200 text-emerald-700'
              : 'bg-white border-slate-200 text-slate-600 hover:bg-slate-50'">
            {{ preset.label }}
          </button>
          }
          @if (filters().fromDate || filters().toDate) {
          <button type="button" (click)="clearDates()"
            class="text-md font-medium px-3 py-1.5 rounded-full border border-slate-200 bg-white text-slate-400 hover:text-slate-600 transition-colors">
            Clear
          </button>
          }
        </div>

        <div class="flex flex-col sm:flex-row gap-x-4">
          <!-- From Date -->
          <mat-form-field appearance="outline" class="flex-1 min-w-0">
            <mat-label>From Date</mat-label>
            <input matInput [matDatepicker]="fromPicker" [max]="today" [formField]="reportForm.fromDate"
              placeholder="Choose a date" />
            <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
            <mat-datepicker #fromPicker></mat-datepicker>
          </mat-form-field>

          <!-- To Date -->
          <mat-form-field appearance="outline" class="flex-1 min-w-0">
            <mat-label>To Date</mat-label>
            <input matInput [matDatepicker]="toPicker" [max]="today" [formField]="reportForm.toDate"
              placeholder="Choose a date" />
            <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
            <mat-datepicker #toPicker></mat-datepicker>
          </mat-form-field>

          <div class="w-full sm:w-auto sm:pt-2">
            <button mat-raised-button type="button" (click)="download()" [disabled]="downloading()"
              class="inline-flex items-center gap-1.5 bg-emerald-600 rounded-md border border-gray-300 px-3 py-1.5 text-sm text-white transition">
              <mat-icon class="!h-4 !w-4 !text-[16px]">download</mat-icon>
              Download
            </button>
          </div>
        </div>

        <div class="flex items-start gap-1 mt-1 text-xs leading-4" [ngClass]="hintClass()">
          <mat-icon class="flex-shrink-0" [svgIcon]="hintIcon()"></mat-icon>
          <span class="p-1">{{ hint() }}</span>
        </div>

        @if (errorMessage()) {
        <div class="mt-3 flex items-start gap-2 rounded-lg bg-rose-50 border border-rose-200 px-3 py-2">
          <mat-icon class="!text-rose-600 !text-lg !w-5 !h-5 !leading-none flex-shrink-0">error_outline</mat-icon>
          <p class="text-xs text-rose-700">{{ errorMessage() }}</p>
        </div>
        }
      </div>
    </div>
  </div>

</section>